module.exports = __webpack_public_path__ + "static/media/Doctor.92df80af.jpg";